export enum TabState {
    MARINES,
    PLANS,
    GROUPS,
  }
